<template>
  <OmtGrid>
    <OmtRow>
      <OmtTypography as="h1-bold" mb="24px"> Protocolo {{ protocol }} </OmtTypography>
    </OmtRow>
    <OmtRow :mobileEnd="1" :desktopEnd="5" mb="16px">
      <TextTile :title="'Assunto'" :description="detail.title" />
    </OmtRow>
    <OmtRow :mobileEnd="2" :desktopStart="6" mb="16px">
      <TextTile :title="'Data da solicitação'" :description="detail.createdAt" />
    </OmtRow>

    <OmtRow :mobileStart="1" mb="16px">
      <TextTile :title="'Beneficiário'" :description="detail.beneficiaryName" />
    </OmtRow>

    <OmtRow :mobileEnd="1" :desktopEnd="5" mb="16px">
      <TextTile :title="'Código beneficiário'" :description="detail.beneficiaryCode" />
    </OmtRow>

    <OmtRow :mobileEnd="5" :desktopStart="6" mb="16px">
      <CFlex direction="column">
        <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> Status </OmtTypography>
        <StatusTile :label="detail.statusDsc" :color="statusColor" />
      </CFlex>
    </OmtRow>

    <OmtRow v-if="hasPendency" :desktopEnd="12" backgroundColor="#F6F6F9" borderRadius="8px" w="100%">
      <CFlex borderRadius="8px" flexDirection="Column">
        <CFlex pl="10px" pt="16px" pb="14px" align-items="center">
          <img :src="IconOmint" />
          <OmtTypography as="p1-bold"> Para continuidade da análise, solicitamos: </OmtTypography>
        </CFlex>
        <CFlex pl="35px" pb="16px">
          <ol>
            <li>O envio do pedido médico com a assinatura do médico solicitante.</li>
            <li>Data das sessões.</li>
          </ol>
        </CFlex>
      </CFlex>
    </OmtRow>

    <OmtRow
      v-if="hasRequestContent"
      :desktopEnd="12"
      border="0.5px solid var(--colors-light-secondary-divider)"
      border-radius="8px"
      mt="16px"
      py="19px"
      px="16px"
      style="display: flex; flex-direction: column"
    >
      <CBox v-if="hasRequest">
        <CFlex mb="15px" align-items="center" style="justify-content: space-between">
          <CFlex>
            <img :src="IconUser" />
            <OmtTypography as="h2-bold" font-size="14px"> Sua solicitação </OmtTypography>
          </CFlex>
          <OmtTypography as="p1" color="#8C8C8C" font-size="14px">{{ detail.doc.createdAt }}</OmtTypography>
        </CFlex>
        <div :class="{ pontilhado: hasResponse.length }">
          <CFlex ps="40px" mb="16px">
            <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" font-size="14px">
              {{ detail.description }}
            </OmtTypography>
          </CFlex>
          <CFlex ps="40px" mb="16px" v-if="pictures.length">
            <CGrid w="100%" :templateColumns="['repeat(auto-fill, minmax(56px, 1fr))']">
              <ImagePreviewer
                v-for="(picture, index) in pictures"
                :key="index"
                v-bind="picture"
                :source="picture.source"
              />
            </CGrid>
          </CFlex>
        </div>
      </CBox>

      <CBox v-if="hasResponse.length">
        <div v-for="(r, idx) in detail.doc.resp" :key="`resp-${idx}`">
          <CFlex mb="15px" align-items="center">
            <img v-if="idx === 0" :src="IconOmint" />
            <OmtTypography as="h2-bold" font-size="14px" :class="{ resp: idx > 0 }"> Resposta Omint </OmtTypography>
          </CFlex>
          <CFlex ps="40px">
            <OmtTypography as="p1" font-size="14px">{{ r }}</OmtTypography>
          </CFlex>
        </div>
      </CBox>
    </OmtRow>

    <OmtRow v-if="hasPendency" justify-content="center">
      <OmtButton height="40px" fontSize="14px" mt="20px" @click="modalPendencies = true">
        Responder pendências
      </OmtButton>
    </OmtRow>

    <PendingResponseModal :reasons="pendencyReasons" :isOpen="modalPendencies" @close="closeModal" @submit="submit" />

    <SendPendency :isOpen="openModalSuccess" :protocol="detail.protocol" @close="closeModalSendPendency" />

    <Footer />
  </OmtGrid>
</template>
<script>
import Footer from "@/components/Molecules/Footer";
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";
import TextTile from "@/components/Molecules/TextTile";
import PendingResponseModal from "@/components/Organisms/Sac/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Sac/SendPendency.vue";
import StatusTile from "@/components/Organisms/Sac/StatusTile.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "DetailOuvidoria",
  components: {
    TextTile,
    StatusTile,
    Footer,
    PendingResponseModal,
    SendPendency,
    ImagePreviewer
  },
  data() {
    return {
      detail: {},
      modalPendencies: false,
      openModalSuccess: false,
      pictures: []
    };
  },
  computed: {
    ...mapState("sac", ["complaints"]),
    protocol() {
      return this.$route.params.protocol ?? "";
    },
    statusColor() {
      switch (this.detail.statusCode) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        case "T":
          return "var(--colors-light-primary-gray2)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },
    hasPendency() {
      return this.detail?.statusCode === "P" && this.detail?.pendency.ticket > 0;
    },
    hasDoc() {
      const idDoc = this.detail?.doc?.id ?? 0;
      return idDoc > 0;
    },
    hasResponse() {
      const raw = this.detail?.doc?.resp;
      if (!raw) return [];
      const arr = Array.isArray(raw) ? raw : [raw];
      return arr.map(response => String(response).trim()).filter(response => response.length > 0);
    },
    pendencyReasons() {
      if (!this.hasPendency) return [];
      return this.detail?.pendency?.reasons ?? [];
    },
    IconUser() {
      return process.env.VUE_APP_BASE_URL + "images/Group3303.png";
    },
    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    },
    hasRequestContent() {
      const hasDescription = String(this.detail?.description ?? "").trim().length > 0;
      const hasPictures = (this.pictures?.length ?? 0) > 0;
      const hasResponses = (this.hasResponse?.length ?? 0) > 0;
      return !!(hasDescription || hasPictures || hasResponses || this.hasPendency);
    },
    hasRequest() {
      return !!(this.detail?.description?.trim() || this.pictures?.length);
    }
  },
  methods: {
    ...mapActions("sac", ["fetchComplaintDetail", "fetchProtocolDetailImage", "getDocumentUrl", "returnRequestTicket"]),
    async getDetail() {
      const detail = await this.fetchComplaintDetail({
        protocol: this.protocol
      });
      if (!detail) {
        this.$router.replace("/ouvidoria");
        return;
      }
      this.detail = detail;
      this.loadPictures();
    },
    loadPictures() {
      if (!this.detail?.pictures?.length) return;
      this.detail.pictures.forEach(p =>
        this.fetchProtocolDetailImage({ documento: p, original: false }).then(source =>
          this.pictures.push({
            id: p,
            source: source,
            loadModalImage: () => this.loadPicture(p)
          })
        )
      );
    },
    async loadPicture(id) {
      return await this.fetchProtocolDetailImage({ documento: id, original: true });
    },
    closeModal() {
      this.modalPendencies = false;
    },
    closeModalSendPendency() {
      this.openModalSuccess = false;
    },
    async submit({ pictures, obs }) {
      if (!this.hasPendency) return;
      let response = {};
      try {
        await this.$root.$emit("show-loading");
        response = await this.returnRequestTicket({
          protocol: this.protocol,
          pictures,
          obs
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }

      if (response && response.Data) {
        this.protocolANS = response.Data.protocoloANS;
        this.modalPendencies = false;
        this.openModalSuccess = true;
        const detail = await this.fetchProtocolDetail({
          protocol: this.protocol
        });
        if (detail) {
          this.detail = detail;
        }
      } else {
        await this.$toast({
          description: "Não foi possivel registrar o atendimento.\nServiço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      }
    },
    async download() {
      const url = await this.getDocumentUrl({ protocol: this.protocol });
      window.open(url, "_blank");
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
img {
  margin-right: 16px;
}
.pontilhado {
  overflow: auto;
  margin-left: 10px;
  border-left: 1px dashed #8c8c8c;
  margin-bottom: 10px;
}
</style>
